import { CivilUnionAnscNotificationsResidentCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import ResearchCivilUnionAnscNotificationCivilStatusShared from 'shell/components/shared/ansc-notifications/research-civil-union';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchCivilUnionAnscNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchCivilUnionAnscNotificationCivilStatusShared
        items={CivilUnionAnscNotificationsResidentCancellationsCrumbs()}
        scope={IdAmbito.Cancellazioni}
      />
    </Fragment>
  );
};

ResearchCivilUnionAnscNotificationCivilStatusPage.displayName =
  'Research Civil Union Notifications Page component';

export default ResearchCivilUnionAnscNotificationCivilStatusPage;
